import { getOrderPayoutsAsync } from 'services/orderPayoutService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { SWRResponse } from 'swr';

export const SWR_ORDER_PAYOUTS_ENDPOINT = 'orders-payouts';

type SWROrderPayoutsData = Awaited<ReturnType<typeof getOrderPayoutsAsync>>;

const useOrderPayouts = (
  orderId: number,
  shouldFetch = true
): SWRResponse<SWROrderPayoutsData, AxiosError> =>
  useSWR(
    shouldFetch ? [SWR_ORDER_PAYOUTS_ENDPOINT, orderId] : null,
    async () => await getOrderPayoutsAsync(orderId)
  );

export default useOrderPayouts;
